/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import Types from '../constants/actionTypes';

const initialState = {
  expandedItems: [],
  lists: {}
};

const listReducer = (state = initialState, action) => {
  const { expandedItems, lists } = state;
  const { item, newList, listId } = action;
  let newExpandedItems = expandedItems.slice(0);
  const listsCopy = JSON.parse(JSON.stringify(lists));

  switch (action.type) {
    case Types.TOGGLE_EXPANDED_ITEM:
      if (expandedItems.findIndex((i) => i.id === item.id) > -1) {
        newExpandedItems = expandedItems.filter((i) => i.id !== item.id);
      } else {
        newExpandedItems.push(item);
      }
      return {
        ...state,
        expandedItems: newExpandedItems
      };
    case Types.EXPAND_ITEM:
      if (!expandedItems.find((i) => i.id === item.id)) {
        newExpandedItems.push(item);
      }
      return {
        ...state,
        expandedItems: newExpandedItems
      };
    case Types.COLLAPSE_ITEM:
      newExpandedItems = expandedItems.filter((i) => i.id !== item.id);
      return {
        ...state,
        expandedItems: newExpandedItems
      };
    case Types.ADD_LIST_SIZE:
      listsCopy[newList.id] = { height: newList.height, width: newList.width };
      return {
        ...state,
        lists: listsCopy
      };
    case Types.REMOVE_LIST_SIZE:
      delete listsCopy[listId];
      return {
        ...state,
        lists: listsCopy
      };
    default:
      return state;
  }
};

export default listReducer;
